/* istanbul ignore file */

// eslint-disable-next-line @typescript-eslint/consistent-type-imports

export var applyKeyframe = function applyKeyframe(keyframe) {
  return function () {
    return process.env.NODE_ENV === 'test' ? keyframe.getName() : keyframe;
  };
};